<header>
    <mat-toolbar class="border-primary-700 border-b !bg-white fixed top-0 z-50">
        <mat-toolbar-row class="!p-0">
            <span
                class="ml-10 text-tertiary-900 font-normal text-xl xl:text-2xl 2xl:text-3xl"
            >
                @if (applicationState$ | async; as applicationState) {
                    FCC Licensing Application Template:
                    {{ applicationState.applicationTemplateInformation!.name }}
                }
            </span>

            <div class="mx-5 flex justify-end w-full">
                <app-header-dropdown [isMobile]="false"></app-header-dropdown>
            </div>
        </mat-toolbar-row>
    </mat-toolbar>
</header>
